export default "__VITE_ASSET__Xk$Vc2Cq__"